<div class="ne-message-picker">
  <Header close="{toggleMessageModal}" logoSrc={logoSrc} />

  <Title>
    Not sure what to write?
    <span slot="subtitle">
      Start off with one of our messages!
    </span>
  </Title>

  <Occasions label="Occasion" select="{(event) => select(event.target.value)}" options={occasions}/>

  <div class="ne-message-label">Choose a Message</div>
  <Messages messages={messages} choose="{(event) => choose(event.target)}"/>

  <span class="ne-button-container">
    <PrimaryButton trackingId='use message' click="{update}">
      Use this Message
    </PrimaryButton>
  </span>
</div>

<style>
  .ne-button-container {
    grid-column: 1;
    justify-self: center;
    align-self: center;
  }

  .ne-message-picker {
    max-width: 400px;
    padding: 1em;
    background-color: #fff;
    justify-self: center;
    align-self: center;
    display: block;
    position: relative;
    z-index: 1;
    max-height: 100%;
  }
</style>

<script>
  import Title from './Title.html';
  import PrimaryButton from './PrimaryButton.html';
  import Messages from './Messages.html';
  import Header from './Header.html';
  import Occasions from './Occasions.html';

  export let chosenMessage;
  export let setText;
  export let toggleMessageModal;
  export let logoSrc;
  export let select;
  export let occasions;
  export let messages;
  export let choose;

  function update() {
    const text = chosenMessage ? chosenMessage.text : null;
    text
      ? (() => {
        setText(text.state);
        toggleMessageModal();
      })()
      : toggleMessageModal();
  }
</script>
